import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { SupplyContractMeteringPointListItem } from '@gasbi/shared/web';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const meteringPointsApi = createApi({
  reducerPath: 'meteringPointsApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL }),
  tagTypes: ['MeteringPoints'],
  endpoints: builder => ({
    getMeteringPointsByContract: builder.infiniteQuery<
      SupplyContractMeteringPointListItem[],
      { contractId: string } & FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/metering-points/by-contract',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: (_, __, { contractId }) => [
        { type: 'MeteringPoints', id: contractId },
      ],
    }),
  }),
});

export const useGetMeteringPointsByContractInfiniteQuery =
  normalizeInfiniteQueryData<SupplyContractMeteringPointListItem>(
    meteringPointsApi.useGetMeteringPointsByContractInfiniteQuery,
  );
